import React from "react";
import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";

export default function AnalyticsPage() {
  return (
    <DashboardLayout activeTab="analytics">
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
          <p className="text-gray-600">Business performance and insights</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <BarChart3 className="h-5 w-5 text-blue-500" />
              Analytics Coming Soon
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-500">
              Advanced analytics and reporting features are being updated. Check back soon.
            </p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
